import { UserService } from '@core/services/user/UserService';
import { createMergedAPI } from '@core/utils/services/paginatedAPIsMerger';

type API = ReturnType<(typeof UserService)['getInstance']>['fetchBets'];
type Await<T> = T extends PromiseLike<infer U> ? U : T;

type History = Await<ReturnType<API>>[0];

function sortHistoriesNewestFirst(a: History, b: History) {
    if (!a) {
        return false;
    }
    if (!b) {
        return true;
    }
    return a.date > b.date;
}

export function createGetBets(): { mergedFetch: API; restore: () => void } {
    return createMergedAPI((...args) => {
        return UserService.getInstance().fetchBets(...args);
    }, (...args) => {
        return UserService.getInstance().fetchVirtualsPlays(...args);
    }, sortHistoriesNewestFirst);
}
